import { render, staticRenderFns } from "./InstantEmergency.vue?vue&type=template&id=031b3f2e&scoped=true&"
import script from "./InstantEmergency.vue?vue&type=script&lang=ts&"
export * from "./InstantEmergency.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031b3f2e",
  null
  
)

export default component.exports